export default {
	"users_register": {
	    "registerPhone": "手机注册",
	    "registerEmail": "邮箱注册",
	    "hasAccount": "已有账号？",
	    "agree": "我同意",
	    "agreement": "用户协议",
	    "and": "和",
	    "policy": "隐私政策",
	    "logoutNotice": "永久注销",
	    "submit": "提交",
	    "selectArea": "选择常住地区",
	    "countryOrRegion": "国家/地区",
	    "change": "更换",
	    "defaultRegion": "中国内地",
	    "AE": "阿拉伯联合酋长国",
	    "search": "搜索热门国家/地区",
	    "reminder": "温馨提示",
	    "reminderTips": "选择【",
	    "reminderTips2": "】作为常住地，可享受该地及周边的专享优惠。选定后将不可更改。确定选择吗？",
	    "confirm": "确定",
	    "cancel": "取消",
	    "setPassword": "设置密码",
	    "registerByEmail": "请点击其中的链接来完成您的账户注册。",
	    "activeSuc": "激活成功",
	    "activeing": "正在激活",
	    "activeAgain": "再次激活",
	    "activeFail": "激活失败",
	    "verified": "我已验证",
	    "registerSuccess": "注册成功"
	},
	"users_login": {
        "loginPhone": "手机登录",
        "loginEmail": "邮箱登录",
        "register": "账号注册",
        "inputPhone": "请输入手机号码",
        "inputPassword": "请输入密码",
        "forgetPassword": "忘记密码",
        "login": "登录",
        "goToLogin": "去登录",
        "inputEmail": "请输入邮箱号",
        "smsCode": "短信验证码",
        "inputSMSCode": "请输入短信验证码",
        "noReceiveCode": "没收到验证码？",
        "resend": "重新发送",
        "nextStep": "下一步",
        "findByPhone": "通过手机找回",
        "findByEmail": "通过邮箱找回",
        "verifyByEmail": "请到邮箱验证",
        "sendEmailTo": "我们已发送一封电子邮件到",
        "findYourPassword": "请点击其中的链接，并按步骤操作来找回您的密码",
        "noReceiveEmail": "收不到邮件？请检查您的垃圾邮件和已删除邮件目录下是否有来自 glocalme@ucloudlink.com 的邮件。",
        "or": "或",
        "resetPassword": "重设密码",
        "oldFormat": "至少6个字符",
        "passwordFormat": "6-20个字符(字母、数字或符号的组合)",
        "completeLogin": "完成并登录",
        "resetPasswordSuc": "重设密码成功",
        "backToGlocalMe": "请回到 GlocalMe Connect 登录体验",
        "activeReminder": "账户未激活，请前往该邮箱，点击激活链接来完成您的账户注册。",
        "known": "知道了"
    },
    "modify_information": {
        "account": "账号",
        "name": "姓名",
        "identification": "证件号",
        "countryName": "常住地区",
        "id": "身份信息",
        "edit": "编辑",
        "complete": "完成",
        "placeholderFirstName": "请输入您的姓氏",
        "placeholderName": "请输入您的名字",
        "firstName": "姓氏",
        "lastName": "名字",
        "placeholderID": "请输入您的身份证/VISA卡/驾驶号",
        "isNull": "未填写",
        "onlyNumber": "只能输入数字或字母",
        "IDTip": "证件号只能输入数字或字母"
    },
    "route.email":"邮箱注册",
    "route.mobilephone":"手机注册",
    "register.Rplace":"请选择注册地",
    "register.Uagreement":"请同意用户协议",
    "register.UnhaveAccount":"账号未输入",
    "register.AccountError":"账号格式不对",
    "register.RegisterChannel":"注册渠道",
}


// WEBPACK FOOTER //
// ./src/lang/zh/register.js